import { NetworkConfiguration } from "../../network/networkConfriguation";
import { callAPI } from "../../network/networkConnection";

const getAllOrders = (queryParams) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl +
      NetworkConfiguration.GET_ORDERS +
      queryParams,
      "GET",
      {
        "Content-Type": "application/json",
      }
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const getDashboardOrderStats = () => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl + NetworkConfiguration.GET_ORDERS + "/dashboard-stats",
      "GET",
      {
        "Content-Type": "application/json",
      }
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const getOrderById = (id) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl +
      NetworkConfiguration.GET_ORDER_BY_ID +
      `/${id}`,
      "GET",
      {
        "Content-Type": "application/json",
      }
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const getFailedOrders = (queryParams) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl + NetworkConfiguration.FAILED_ORDERS +
      queryParams,
      "GET",
      {
        "Content-Type": "application/json",
      }
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const getFailedOrdersCount = () => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl + NetworkConfiguration.FAILED_ORDERS + "/count",
      "GET",
      {
        "Content-Type": "application/json",
      }
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const getAllTicket = (queryParams) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl +
      NetworkConfiguration.GET_ADMIN_TICKET +
      queryParams,
      "GET",
      {
        "Content-Type": "application/json",
      }
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const addRefund = (payload, id) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl +
      NetworkConfiguration.GET_ORDER_REFUND +
      id +
      "/refund",
      "POST",
      {},
      payload
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const getRefundedByOrderId = (id) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl +
      NetworkConfiguration.GET_ORDER_REFUND +
      id +
      "/refund",
      "GET",
      {
        "Content-Type": "application/json",
      }
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
const getprocessingOrder = () => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl + NetworkConfiguration.GET_POCESSING_ORDERS,
      "GET",
      {
        "Content-Type": "application/json",
      }
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const addExcelTracking = (formData) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl + NetworkConfiguration.UPLOAD_EXCEL_TRACKING,
      "PUT",
      {},
      formData
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const searchUsers = (query) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl + NetworkConfiguration.ADMIN_USERS_SEARCH + `?query=${encodeURIComponent(query)}`,
      "GET",
      {
        "Content-Type": "application/json",
      }
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const createManualOrder = (orderData) => {
  return new Promise((resolve, reject) => {
    // Clean up undefined values before stringifying
    const cleanData = JSON.parse(JSON.stringify(orderData));

    callAPI(
      process.env.REACT_APP_APIUrl + NetworkConfiguration.CREATE_MANUAL_ORDER,
      "POST",
      {
        "Content-Type": "application/json",
      },
      JSON.stringify(cleanData)
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const searchProductBySku = (sku) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl + NetworkConfiguration.ADMIN_SEARCH_PRODUCT_BY_SKU + `?sku=${encodeURIComponent(sku)}`,
      "GET",
      {
        "Content-Type": "application/json",
      }
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const getOrderFilterValues = (column) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl +
      NetworkConfiguration.GET_ORDERS +
      `/filter-values?column=${column}`,
      "GET",
      {
        "Content-Type": "application/json",
      }
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const raiseTicketForOrder = (orderId, payload) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl +
      NetworkConfiguration.GET_ORDERS +
      `/${orderId}/ticket`,
      "POST",
      {
        "Content-Type": "application/json",
      },
      payload
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const uploadFailedOrdersWithUserId = (formData) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl + NetworkConfiguration.UPLOAD_FAILED_ORDERS_WITH_USERID,
      "POST",
      {},
      formData
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const updateFailedOrderRemark = (orderId, remark) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl + NetworkConfiguration.UPDATE_FAILED_ORDER_REMARK + `/${orderId}/remark`,
      "PUT",
      {
        "Content-Type": "application/json",
      },
      JSON.stringify({ remark })
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const deleteFailedOrder = (orderId, password, orderIds = null) => {
  return new Promise((resolve, reject) => {
    // If orderIds is provided, it's a bulk delete (use first orderId as placeholder in URL)
    // The API will check for orderIds in the body
    const url = orderIds && Array.isArray(orderIds) && orderIds.length > 0
      ? process.env.REACT_APP_APIUrl + NetworkConfiguration.DELETE_FAILED_ORDER + `/${orderIds[0]}`
      : process.env.REACT_APP_APIUrl + NetworkConfiguration.DELETE_FAILED_ORDER + `/${orderId}`;

    const body = orderIds && Array.isArray(orderIds) && orderIds.length > 0
      ? JSON.stringify({ orderIds, password })
      : JSON.stringify({ password });

    callAPI(
      url,
      "DELETE",
      {
        "Content-Type": "application/json",
      },
      body
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const deleteOrder = (orderId, password, orderIds = null) => {
  return new Promise((resolve, reject) => {
    const url = orderIds && Array.isArray(orderIds) && orderIds.length > 0
      ? process.env.REACT_APP_APIUrl + NetworkConfiguration.DELETE_ORDER + `/${orderIds[0]}`
      : process.env.REACT_APP_APIUrl + NetworkConfiguration.DELETE_ORDER + `/${orderId}`;

    const body = orderIds && Array.isArray(orderIds) && orderIds.length > 0
      ? JSON.stringify({ orderIds, password })
      : JSON.stringify({ password });

    callAPI(
      url,
      "DELETE",
      {
        "Content-Type": "application/json",
      },
      body
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const splitOrder = (orderId, offerIdsToExtract) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl + NetworkConfiguration.GET_ORDERS + `/${orderId}/split`,
      "POST",
      {
        "Content-Type": "application/json",
      },
      JSON.stringify({ offerIdsToExtract })
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const adminBulkPayment = (orderIds) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl + NetworkConfiguration.ADMIN_BULK_PAYMENT,
      "POST",
      {
        "Content-Type": "application/json",
      },
      JSON.stringify({ orderIds })
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const exportOrdersDateWise = (params) => {
  return new Promise((resolve, reject) => {
    const queryString = new URLSearchParams(params).toString();
    callAPI(
      process.env.REACT_APP_APIUrl + NetworkConfiguration.ADMIN_ORDERS_EXPORT_DATE_WISE + `?${queryString}`,
      "GET",
      {
        "Content-Type": "application/json",
      }
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const exportAllOrders = (params) => {
  return new Promise((resolve, reject) => {
    const queryString = new URLSearchParams(params).toString();
    callAPI(
      process.env.REACT_APP_APIUrl + NetworkConfiguration.ADMIN_ORDERS_EXPORT_ALL + `?${queryString}`,
      "GET",
      {
        "Content-Type": "application/json",
      }
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const updateOrderConfirmation = (orderId, value) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl + NetworkConfiguration.GET_ORDERS + `/${orderId}/confirmation`,
      "PUT",
      {
        "Content-Type": "application/json",
      },
      JSON.stringify({ value })
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const adminEditOrder = (orderId, payload) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl +
        NetworkConfiguration.ADMIN_EDIT_ORDER +
        `/${orderId}/edit`,
      "PUT",
      {
        "Content-Type": "application/json",
      },
      JSON.stringify(payload)
    )
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};

/** Single request: full product docs for edit-order modal (replaces N× getProductById). */
const fetchProductsForEditOrder = (productIds) =>
  callAPI(
    process.env.REACT_APP_APIUrl + 
     NetworkConfiguration.ADMIN_ORDER_EDIT_PRODUCTS_BY_IDS,
    "POST",
    { "Content-Type": "application/json" },
    JSON.stringify({ productIds })
  );

export const orderApiService = {
  getAllOrders,
  getDashboardOrderStats,
  getOrderById,
  getFailedOrders,
  getFailedOrdersCount,
  getAllTicket,
  addRefund,
  getRefundedByOrderId,
  getprocessingOrder,
  addExcelTracking,
  searchUsers,
  createManualOrder,
  searchProductBySku,
  uploadFailedOrdersWithUserId,
  getOrderFilterValues,
  updateFailedOrderRemark,
  deleteFailedOrder,
  deleteOrder,
  splitOrder,
  raiseTicketForOrder,
  adminBulkPayment,
  exportOrdersDateWise,
  exportAllOrders,
  updateOrderConfirmation,
  adminEditOrder,
  fetchProductsForEditOrder,
};
